import { render, staticRenderFns } from "./customer-types-grid.vue?vue&type=template&id=2b8c6ada&"
import script from "./customer-types-grid.ts?vue&type=script&lang=ts&"
export * from "./customer-types-grid.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports